import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const SearchPage = Scrivito.provideObjClass("SearchPage", {
  attributes: {
    ...defaultPageAttributes,
    backgroundImage: ["reference", { only: "Image" }],
    ...metadataAttributes,
  },
  extractTextAttributes: [],
});

export default SearchPage;
